<button
  class="toggle-button"
  [attr.data-variant]="variant"
  [attr.data-size]="size"
  [attr.data-position]="position"
  [attr.data-row-position]="rowPosition !== 'only' ? rowPosition : null"
  [attr.data-pressed]="pressed"
  [attr.data-disabled]="disabled"
  [disabled]="disabled"
  [attr.aria-label]="computedAriaLabel"
  [attr.aria-pressed]="computedAriaPressed"
  [style.grid-column]="'span ' + gridSpan"
  [umssTooltip]="title || ''"
  (click)="onButtonClick($event)"
  type="button"
>
  <!-- Left Icon (or checkmark when selected and checkmarkPosition=left) -->
  <span
    *ngIf="(checkmarkPosition === 'left' && pressed) || leftIconName"
    @horizontalCollapseInOut
    class="icon left-icon"
    aria-hidden="true"
  >
    <umss-icon
      [name]="
        checkmarkPosition === 'left' && pressed
          ? 'phosphorCheckBold'
          : leftIconName!
      "
      [size]="
        checkmarkPosition === 'left' && pressed ? checkmarkIconSize : iconSize
      "
    />
  </span>

  <!-- Button text -->
  <span class="button-text">{{ label }}</span>

  <!-- Right Icon (or checkmark when selected and checkmarkPosition=right) -->
  <span
    *ngIf="(checkmarkPosition === 'right' && pressed) || rightIconName"
    @horizontalCollapseInOut
    class="icon right-icon"
    aria-hidden="true"
  >
    <umss-icon
      [name]="
        checkmarkPosition === 'right' && pressed
          ? 'phosphorCheckBold'
          : rightIconName!
      "
      [size]="
        checkmarkPosition === 'right' && pressed ? checkmarkIconSize : iconSize
      "
    />
  </span>
</button>
